/**
 * Дедуп телефона в формах создания: проверка стреляет только на полном
 * номере (9 цифр), пока набирают — молчим. Живой режим — phone-check
 * гейтвея, мок — phoneOwner по MOCK_CLIENTS (checkPhone сам решает).
 */

import {useQuery} from '@tanstack/react-query';

import {checkPhone} from '@services/clients';
import {keys} from '@queries/keys';
import {phoneDigits} from '@utils/phone';

type PhoneOwnerState = {
  /** ФИО владельца номера; null — свободен или ещё не проверен */
  owner: string | null;
  /** Номер полный и проверка завершена — можно показывать вердикт */
  checked: boolean;
};

export const usePhoneOwner = (phone: string): PhoneOwnerState => {
  const digits = phoneDigits(phone);
  const complete = digits.length === 9;

  const {data, isFetched} = useQuery({
    queryKey: keys.clients.phoneCheck(digits),
    queryFn: () => checkPhone(digits),
    enabled: complete,
    staleTime: 30_000,
  });

  return {owner: data ?? null, checked: complete && isFetched};
};
